import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AuthCard from "../components/AuthShell";
import { api } from "../lib/api";

export default function SetPasswordPage({ mode = "set" }) {
    const isReset = mode === "reset";
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    const navigate = useNavigate();

    const onSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (loading) return;
        setError("");
        if (password.length < 10 || !/[A-Za-z]/.test(password) || !/\d/.test(password)) {
            setError("La password deve avere almeno 10 caratteri, una lettera e una cifra.");
            return;
        }
        if (password !== confirm) {
            setError("Le password non coincidono.");
            return;
        }
        if (!token) {
            setError("Token mancante. Apri di nuovo il link ricevuto via email.");
            return;
        }
        setLoading(true);
        try {
            const endpoint = isReset ? "/auth/reset-password" : "/auth/set-password";
            await api.post(endpoint, { token, new_password: password });
            setDone(true);
            setTimeout(() => navigate("/login", { replace: true }), 1600);
        } catch (err) {
            const msg = err?.response?.data?.detail;
            setError(typeof msg === "string" ? msg : "Errore durante l'operazione.");
        } finally {
            setLoading(false);
        }
    };

    const title = isReset ? "Reimposta la password" : "Imposta la tua password";
    const subtitle = isReset
        ? "Crea una nuova password per il tuo account."
        : "Crea una password sicura per accedere alla piattaforma.";
    const cta = isReset ? "Reimposta password" : "Imposta password";

    return (
        <AuthCard title={title} subtitle={subtitle} testId="setpw-shell">
            {done ? (
                <div className="el-note" data-testid="setpw-done">
                    Password impostata. Ti reindirizzo al login…
                </div>
            ) : (
                <form onSubmit={onSubmit} method="post" action="#" noValidate data-testid="setpw-form">
                    <label htmlFor="new-password" className="el-label">Nuova password</label>
                    <input
                        id="new-password"
                        className="el-field"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="••••••••••"
                        autoComplete="new-password"
                        required
                        data-testid="setpw-new-input"
                    />

                    <label htmlFor="confirm-password" className="el-label">Conferma password</label>
                    <input
                        id="confirm-password"
                        className="el-field"
                        type="password"
                        value={confirm}
                        onChange={(e) => setConfirm(e.target.value)}
                        placeholder="••••••••••"
                        autoComplete="new-password"
                        required
                        data-testid="setpw-confirm-input"
                    />

                    {error ? (
                        <div className="el-err" data-testid="setpw-error">{error}</div>
                    ) : null}

                    <button
                        type="submit"
                        className="el-btn"
                        disabled={loading}
                        onClick={onSubmit}
                        data-testid="setpw-submit-btn"
                    >
                        {loading ? "Salvataggio…" : cta}
                    </button>

                    <div className="el-foot">
                        <Link to="/login" data-testid="setpw-back-login-link">Torna ad accedi</Link>
                    </div>
                </form>
            )}
        </AuthCard>
    );
}
